import "./src/styles/global.scss"

const renderMermaidDiagrams = () => {
  if (typeof document === "undefined") {
    return
  }

  const codeBlocks = Array.from(
    document.querySelectorAll("pre > code.language-mermaid")
  )

  if (codeBlocks.length === 0) {
    return
  }

  const diagrams = codeBlocks.reduce((items, codeBlock) => {
    const pre = codeBlock.parentElement

    if (!pre || pre.classList.contains("mermaid-source")) {
      return items
    }

    const diagram = document.createElement("div")
    diagram.className = "mermaid"
    diagram.textContent = codeBlock.textContent
    pre.parentNode.replaceChild(diagram, pre)
    items.push(diagram)

    return items
  }, [])

  if (diagrams.length === 0) {
    return
  }

  const mermaidModule = require("mermaid")
  const mermaid = mermaidModule.default || mermaidModule
  const isDarkMode = document.body.classList.contains("dark")

  mermaid.initialize({
    startOnLoad: false,
    securityLevel: "strict",
    theme: isDarkMode ? "dark" : "default",
    fontFamily: "inherit",
    flowchart: {
      curve: "basis",
      htmlLabels: false,
    },
  })
  mermaid.init(undefined, diagrams)
}

const scheduleMermaidRender = () => {
  if (typeof window === "undefined") {
    return
  }

  window.requestAnimationFrame(renderMermaidDiagrams)
}

export const onClientEntry = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister())
    })
  }
}

export const onInitialClientRender = scheduleMermaidRender

export const onRouteUpdate = scheduleMermaidRender
